export * from './NavigatorItemMobile';
export type { NavigatorItemMobileProps } from './types';
